import React from 'react';

const CartSummary = ({ cartDict, onUpdate }) => {
  // Convert dictionary entries into an array
// To this:
const cartEntries = Object.entries(cartDict).filter(([_, itemArray]) => {
  return (parseInt(itemArray[1]) || 0) > 0;
});
  // Calculate the grand total
  const totalBill = cartEntries.reduce((acc, [key, itemArray]) => {
    // Destructuring based on your specific order: id, quantity, title, price
    const [_, quantity, __, price] = itemArray;
    
    // Convert strings to numbers for calculation
    const qtyNum = parseInt(quantity) || 0;
    const priceNum = parseFloat(price) || 0;
    
    return acc + (qtyNum * priceNum);
  }, 0);

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <table style={tableStyle}>
        <thead>
          <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #dee2e6' }}>
            <th style={cellStyle}>Product Title</th>
            <th style={cellStyle}>Price(Rs)</th>
            <th style={cellStyle}>Quantity</th>
            <th style={cellStyle}>Subtotal</th>
          </tr>
        </thead>
        <tbody>
          {cartEntries.map(([key, itemArray]) => {
            // Mapping: 0:id, 1:quantity, 2:title, 3:price
            const [id, quantity, title, price] = itemArray;
            
            // Clean the strings for math
            const cleanPrice = parseFloat(price) || 0;
            const cleanQty = parseInt(quantity) || 0;
            const subtotal = cleanPrice * cleanQty;

            return (
              <tr key={key} style={{ borderBottom: '1px solid #eee' }}>
                <td style={cellStyle}>{title}</td>
                <td style={cellStyle}>{cleanPrice.toFixed(2)}</td>
                {/* <td style={cellStyle}>{cleanQty}</td> */}
                <td style={{ ...cellStyle, display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <button 
                    style={btnStyle} 
                    onClick={() => onUpdate(id, cleanQty - 1, title, price)}
                  >-</button>
                  
                  <span style={{ minWidth: '20px', textAlign: 'center' }}>{cleanQty}</span>
                  
                  <button 
                    style={btnStyle} 
                    onClick={() => onUpdate(id, cleanQty + 1, title, price)}
                  >+</button>
                </td>
                <td style={cellStyle}>{subtotal.toFixed(2)}</td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
            <td colSpan="3" style={{ ...cellStyle, textAlign: 'right' }}>Grand Total:</td>
            <td style={{ ...cellStyle, color: '#27ae60' }}>
              {totalBill.toFixed(2)}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

// Internal styles for clean look
const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
  boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
};

const cellStyle = {
  padding: '3px',
  textAlign: 'left',
  border: '1px solid #f0f0f0'
};
// 3. Added button styling for the table
const btnStyle = {
  padding: '2px 8px',
  cursor: 'pointer',
  backgroundColor: '#fff',
  border: '1px solid #ccc',
  borderRadius: '4px',
  fontWeight: 'bold'
};

export default CartSummary;